'use client';

// Lithuanian cart route – reuse the main cart page implementation
export { default } from '../cart';


